import { debounce, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/medical-degrees/actions';
import medicalDegreesApi from 'src/services/api/medical-degrees';

export function* list(action: any) {
  try {
    const response = yield call(medicalDegreesApi.list, action.filters);
    yield put(Creators.medicalDegreesListRequestSuccess(response.data));
  } catch (e) {
    let error = e.response;
    yield put(Creators.medicalDegreesListRequestError(error));
  }
}

export function* watchList() {
  yield debounce(6e2, Types.MEDICAL_DEGREES_LIST_REQUEST, list);
}

export default watchList;
